'use client'

import { ReactNode } from 'react'

import { Button } from '~/components/component-library'
import { useActiveOrgMember } from '~/hooks/org'
import { useWorkspaceAutoEarn } from '~/hooks/useWorkspaceAutoEarn'

const getDisabledReason = ({
  isOwner,
  hasNoEligibleNetwork,
}: {
  isOwner: boolean
  hasNoEligibleNetwork: boolean
}) => {
  if (!isOwner) return 'Only workspace owners can turn this on'
  if (hasNoEligibleNetwork) return 'No network qualifies for auto-earn'
  return undefined
}

// Creates the same workspace transaction as the owner-only toggle in
// Settings > General. Each checklist surface says its own thing about a
// transaction awaiting approval.
export const WorkspaceAutoEarnStepAction = ({
  pendingAction,
}: {
  pendingAction: (transactionId: string) => ReactNode
}) => {
  const orgMember = useActiveOrgMember()
  const { data, toggle, isPending } = useWorkspaceAutoEarn()

  if (data?.pendingTransactionId) {
    return pendingAction(data.pendingTransactionId)
  }

  const disabledReason = getDisabledReason({
    isOwner: orgMember?.role === 'OWNER',
    hasNoEligibleNetwork: data?.eligibleChainIds.length === 0,
  })

  return (
    <Button
      variant="secondary"
      size="small"
      isLoading={isPending}
      isDisabled={!data || !!disabledReason}
      disabledReason={disabledReason}
      onClick={() => {
        toggle(true)
      }}
    >
      Activate
    </Button>
  )
}
